'use client';

import { createPortal } from 'react-dom';
import { useLayoutStore } from '@/stores/layout';

export function CategoryActions({
  children,
  loading = false,
}: {
  children: React.ReactNode;
  loading?: boolean;
}): React.ReactNode {
  const headerElement = useLayoutStore((state) => state.categoryActionsElement);

  return headerElement === null
    ? null
    : createPortal(
        <div data-loading={loading ? '' : undefined} className="flex items-center gap-2">
          {children}
        </div>,
        headerElement,
      );
}
